
  import { Vue, Component, Prop } from "vue-property-decorator";
  import { hslColorFromName } from "@/utils/hslColorFromName";

  import S3Image from "@/components/common/s3-image.vue";
  import Tooltip from "@/components/common/Tooltip.vue";

  import RouteParams from "@/entities/RouteParams";
  import RouteNames from "@/entities/RouteNames";
  import TooltipPlacement from "@/entities/TooltipPlacement";
  import initialsHelper from "@/helpers/cardInfoHelperFunctions/initialsHelper";

  import getDefaultImageName from "@/helpers/getDefaultImageName";
  import imgA from "@/components/icons/staffCardPlaceholders/imgA.vue";
  import imgB from "@/components/icons/staffCardPlaceholders/imgB.vue";
  import imgC from "@/components/icons/staffCardPlaceholders/imgC.vue";
  import imgD from "@/components/icons/staffCardPlaceholders/imgD.vue";
  import imgE from "@/components/icons/staffCardPlaceholders/imgE.vue";
  import imgF from "@/components/icons/staffCardPlaceholders/imgF.vue";
  import imgG from "@/components/icons/staffCardPlaceholders/imgG.vue";
  import imgH from "@/components/icons/staffCardPlaceholders/imgH.vue";
  import imgI from "@/components/icons/staffCardPlaceholders/imgI.vue";
  import imgJ from "@/components/icons/staffCardPlaceholders/imgJ.vue";
  import imgK from "@/components/icons/staffCardPlaceholders/imgK.vue";
  import imgL from "@/components/icons/staffCardPlaceholders/imgL.vue";
  import imgM from "@/components/icons/staffCardPlaceholders/imgM.vue";
  import imgN from "@/components/icons/staffCardPlaceholders/imgN.vue";
  import imgO from "@/components/icons/staffCardPlaceholders/imgO.vue";
  import imgP from "@/components/icons/staffCardPlaceholders/imgP.vue";
  import imgQ from "@/components/icons/staffCardPlaceholders/imgQ.vue";
  import imgR from "@/components/icons/staffCardPlaceholders/imgR.vue";
  import imgS from "@/components/icons/staffCardPlaceholders/imgS.vue";
  import imgT from "@/components/icons/staffCardPlaceholders/imgT.vue";
  import imgU from "@/components/icons/staffCardPlaceholders/imgU.vue";
  import imgV from "@/components/icons/staffCardPlaceholders/imgV.vue";
  import imgW from "@/components/icons/staffCardPlaceholders/imgW.vue";
  import imgX from "@/components/icons/staffCardPlaceholders/imgX.vue";
  import imgY from "@/components/icons/staffCardPlaceholders/imgY.vue";
  import imgZ from "@/components/icons/staffCardPlaceholders/imgZ.vue";


  @Component({
    components: {
      S3Image,
      Tooltip,
      imgA,
      imgB,
      imgC,
      imgD,
      imgE,
      imgF,
      imgG,
      imgH,
      imgI,
      imgJ,
      imgK,
      imgL,
      imgM,
      imgN,
      imgO,
      imgP,
      imgQ,
      imgR,
      imgS,
      imgT,
      imgU,
      imgV,
      imgW,
      imgX,
      imgY,
      imgZ,
    },
  })
  export default class CircleWithInitials extends Vue {
    @Prop({ type: String, default: "" }) readonly title!: string;
    @Prop({ type: String, default: undefined }) readonly id?: string;
    @Prop({ type: String, default: undefined }) readonly route?: RouteNames;
    @Prop({ type: String, default: undefined }) readonly avatar?: string;
    @Prop({ type: String, default: undefined }) readonly customClass?: string;
    @Prop({ type: Boolean, default: false }) readonly large!: boolean;
    @Prop({ type: Boolean, default: false }) readonly primary!: boolean;
    @Prop({ type: String, default: undefined }) readonly background?: string;
    @Prop({ type: Boolean, default: false }) readonly showTooltip!: boolean;
    @Prop({ type: Boolean, default: false }) readonly cursorPointer!: boolean;
    @Prop({ type: Number, default: 2 }) readonly initialSize!: number;
    @Prop({ type: Number, default: 140 }) readonly tooltipWidth!: number;
    @Prop({ type: String, default: TooltipPlacement.BOTTOM }) readonly tooltipPlacement!: TooltipPlacement;

    get circleSizeClasses(): string {
      return this.large ? "h-10 w-10" : "h-8 w-8";
    }

    get cursor(): string {
      return this.cursorPointer ? "cursor-pointer" : "cursor-default";
    }

    get textSizeClasses(): string {
      return this.large ? "" : "text-xs";
    }

    get bgStyle(): object {
      const colors = this.primary ? "#1A7BEE" : this.background;
      return {
        background: colors ? colors : hslColorFromName(this.initial),
      };
    }

    get routeTo(): RouteParams<{id: string}> {
      return {
        name: this.route!,
        params: {id: this.id!}
      }
    }

    get initial(): string {
      return initialsHelper(this.title);
    }

    get defaultImageComponentName(): string {
      return getDefaultImageName(this.title);
    }
  }
